define(function (require, exports, module) {
	 var lazyload = require('../unit/lazyload/lazyload');

	var nationalEntryModule = {};

	nationalEntryModule.init = function(){
		$('.national .national-text li').hover(
			function(){
				var _this = $(this);
				if(_this.hasClass('active')){
					return;
				}
				_this.siblings('li.active').removeClass('active')
				var _tag = _this.attr('class');
				var _bg = $('.national .national-bg');
				_bg.find('li.active').removeClass('active');
				_bg.find('li.'+_tag).addClass('active');
				_this.addClass('active');
				_bg.find('img.hideImg').removeClass('hideImg');
				lazyload.fn.init({"root": $('.national-bg')})
				
				var tt2 = _this.find('.tooltip .tt2');
				if(!tt2.length){
					_this.find('.tooltip .tt1').css({lineHeight:'50px', height:'50px'});
				}
			},
			function(){

			}
		);
	};


  	module.exports = nationalEntryModule;
});



// WEBPACK FOOTER //
// ./src/js/module/nationalEntryModule.js